import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components/macro';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Loading from '../components/Loading';
import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Paper as MuiPaper,
  TextField,
  Typography,
  Button,
  Alert,
  Snackbar,
  TableCell,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  Box,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import { spacing } from '@mui/system';
import { connect } from 'react-redux';
import axios from '../../CustomAxios';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import moment from 'moment';

const Card = styled(MuiCard)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Paper = styled(MuiPaper)(spacing);

function FormDetails({ challanId, user, details }) {
  const navigate = useNavigate();
  const [err, setErr] = useState('');
  const [success, setSuccess] = useState(false);
  const [loader, setLoader] = useState(false);
  const snackRef = useRef(null);
  const [state, setState] = useState({
    open: false,
    vertical: 'top',
    horizontal: 'center',
  });
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const downloadSignedChallan = async (chalan, key) => {
    try {
      setLoader(true);
      const authData = JSON.parse(localStorage.getItem('AuthData'));
      const comp = user?.customer_company?._id;
      let url = '';
      if (authData?.type === 'customer_user') {
        url = `/api/v1/${authData?.type}/${comp}/media/${key}`;
      } else {
        url = `/api/v1/${authData?.type}/media/${key}`;
      }

      fetch(url, {
        headers: {
          Authorization: 'Bearer ' + authData.access_token,
        },
        method: 'GET',
      }).then(async (res) => {
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display:none';
        const file = await res.blob();
        const url = URL.createObjectURL(file);
        a.href = url;
        a.download = details[0].challan_id + '-' + details[0].customer_company.name + '-Signed.pdf';
        a.click();
        window.URL.revokeObjectURL(url);
        setLoader(false);
      });
    } catch (e) {
      setLoader(false);
      console.log(e);
    }
  };

  return (
    <>
      <Button
        ref={snackRef}
        style={{ display: 'none' }}
        onClick={handleClick({ vertical: 'top', horizontal: 'center' })}
      >
        Click
      </Button>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        onClose={handleClose}
        key={vertical + horizontal}
      >
        {err ? (
          <Alert mt={2} mb={4} severity='error'>
            {err}
          </Alert>
        ) : success ? (
          <Alert mt={2} mb={4} severity='success'>
            Signed Challan Uploaded Successfully
          </Alert>
        ) : null}
      </Snackbar>
      <Card mb={6}>
        <CardContent>
          <Paper elevation={3} style={{ padding: '2%' }}>
            <Grid container spacing={5}>
              <Grid item xs={12} md={12} lg={12}>
                <Typography color='primary' variant='h6' gutterBottom>
                  Challan Details
                </Typography>
              </Grid>
              <Grid item xs={12} md={12} lg={6}>
                <TextField
                  type='text'
                  fullWidth
                  label='Challan ID'
                  value={details[0]?.challan_id}
                  inputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} md={12} lg={6}>
                <TextField
                  type='text'
                  fullWidth
                  label='Challan Name'
                  value={details[0]?.name}
                  inputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} md={12} lg={6}>
                <TextField
                  fullWidth
                  name='ap_company'
                  value={`${details[0]?.ap_company?.name} [${details[0]?.ap_company?.company_code}]`}
                  label='AP Company'
                  inputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} md={12} lg={6}>
                <TextField
                  fullWidth
                  name='customer_company'
                  value={details[0]?.customer_company?.name}
                  label='Customer Company'
                  inputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <TextField
                  type='text'
                  fullWidth
                  label='Description'
                  value={details[0]?.description}
                  inputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} md={12} lg={6}>
                <TextField
                  type='text'
                  fullWidth
                  label='Challan Date'
                  value={moment(new Date(details[0]?.challan_date)).format('DD-MM-YYYY | hh:mm A')}
                  inputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} lg={3} md={3}>
                <FormControl fullWidth component='fieldset' variant='standard'>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={Boolean(details[0]?.is_left_for_delivery)}
                        inputProps={{ readOnly: true }}
                      />
                    }
                    label={'LEFT FOR DELIVERY'}
                  />
                </FormControl>
              </Grid>
            </Grid>

            {details[0]?.customer_signed_doc_uploaded && (
              <Grid item xs={12}>
                <Paper
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                  }}
                  mt={3}
                >
                  <Box
                    component='img'
                    width='auto'
                    height='48px'
                    src='/static/img/images/pdf.png'
                    style={{ cursor: 'pointer' }}
                  />
                  <TextField
                    fullWidth
                    margin='dense'
                    m={2}
                    style={{
                      marginLeft: 32,
                      width: '100%',
                    }}
                    inputProps={{ readOnly: true }}
                    id='standard-required'
                    value={
                      details[0].challan_id + '-' + details[0].customer_company.name + '-Signed'
                    }
                  />
                  <Grid item>
                    {loader ? (
                      <CircularProgress
                        style={{
                          marginLeft: 16,
                          marginTop: 8,
                          cursor: 'pointer',
                        }}
                      />
                    ) : (
                      <FileDownloadIcon
                        style={{
                          marginLeft: 16,
                          marginTop: 8,
                          cursor: 'pointer',
                        }}
                        onClick={() => {
                          downloadSignedChallan(details[0], details[0].customer_signed_doc?.Key);
                        }}
                      />
                    )}
                  </Grid>
                </Paper>
              </Grid>
            )}
          </Paper>
        </CardContent>
      </Card>

      <Card mb={6}>
        <CardContent>
          <Paper elevation={3} style={{ padding: '2%' }}>
            <Grid container spacing={5}>
              <Grid item xs={12} md={12} lg={12}>
                <Typography color='primary' variant='h6' gutterBottom>
                  Job Details
                </Typography>
              </Grid>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label='simple table'>
                  <TableHead>
                    <TableRow>
                      <TableCell align='left'>Job Id</TableCell>
                      <TableCell align='left'>Job Name</TableCell>
                      <TableCell align='left'>Plate Name</TableCell>
                      <TableCell align='left'>Quantity</TableCell>
                      <TableCell align='left'>Baking</TableCell>
                      <TableCell align='left'>Color Print</TableCell>
                      <TableCell align='left'>Delivery Charge (₹)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {details.map((row, idx) => (
                      <TableRow
                        hover
                        key={row._id + idx}
                        style={{ cursor: 'pointer' }}
                        onClick={() =>
                          navigate(`/dashboard/jobs/job-details/${row.jobs._id}`, {
                            state: { job: row.jobs },
                          })
                        }
                        sx={{
                          '&:last-child td, &:last-child th': {
                            border: 0,
                          },
                        }}
                      >
                        <TableCell align='left'>{row?.jobs?.job_id}</TableCell>
                        <TableCell align='left'>{row?.jobs?.name}</TableCell>
                        <TableCell align='left'>
                          {row?.jobs?.plates?.plate_details?.height}*
                          {row?.jobs.plates?.plate_details?.width}*
                          {row?.jobs.plates?.plate_details?.thickness}_
                          {row?.jobs.plates?.plate_details?.brand.name}_
                          {row?.jobs.plates?.plate_details?.technology.name}
                        </TableCell>
                        <TableCell align='left'>
                          <div style={{ marginLeft: 20 }}>{row.jobs.plates.quantity}</div>
                        </TableCell>
                        <TableCell align='left'>
                          <div style={{ marginLeft: 20 }}>{row?.jobs?.plates?.bake}</div>
                        </TableCell>
                        <TableCell align='left'>
                          <div style={{ marginLeft: 20 }}>{row?.jobs?.plates?.printout}</div>
                        </TableCell>
                        <TableCell align='left'>
                          <div style={{ marginLeft: 20 }}>
                            {row?.jobs?.delivery_charge !== undefined ? row.jobs.delivery_charge : 0}
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Paper>
        </CardContent>
      </Card>
    </>
  );
}

const getChalanDetails = async (id, setDetails, setLoader, companyId, setOpen, setMsg) => {
  try {
    const authData = JSON.parse(localStorage.getItem('AuthData'));
    const config = {
      headers: {
        Authorization: 'Bearer ' + authData?.access_token,
      },
    };
    let url = '';
    if (authData?.type === 'customer_user') {
      url = `/api/v1/${authData?.type}/${companyId}/challan/${id}`;
    } else {
      url = `/api/v1/${authData?.type}/challan/${id}`;
    }
    const { data } = await axios.get(url, config);
    if (data.success) {
      setDetails(data.data);
      setLoader(false);
    }
  } catch (e) {
    console.log(e.response?.data?.error, 'error');
    setOpen(true);
    setMsg('Invalid challan type');
    setLoader(false);
  }
};

function ChalanDetails({ auths }) {
  const { challan_id } = useParams();
  const [user, setUser] = useState([]);
  const [loader, setLoader] = useState(true);
  const [details, setDetails] = useState([]);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    setUser(auths.user);
    const companyId = auths?.user?.customer_company?._id;
    getChalanDetails(challan_id, setDetails, setLoader, companyId, setOpen, setMsg);
    // eslint-disable-next-line
  }, [auths.user]);

  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title='Alpha Plus' />
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={open}
          onClose={() => setOpen(false)}
        >
          <Alert mt={2} mb={4} severity='error'>
            {msg}
          </Alert>
        </Snackbar>
        <Grid justifyContent='space-between' alignItems='center' container spacing={10} mb={4}>
          <Grid item>
            <Typography
              variant='h4'
              gutterBottom
              display='inline'
              sx={{ fontWeight: 600 }}
              color='primary'
            >
              CHALLAN DETAILS
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label='Breadcrumb' mt={2}>
              <Link component={NavLink} to='/dashboard/tasks'>
                Dashboard
              </Link>
              <Link component={NavLink} to='/dashboard/challan'>
                All Challans
              </Link>
              <Typography>Challan Details</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <FormDetails challanId={challan_id} user={user} details={details} />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, null)(ChalanDetails);